"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createImThemeOptionsZenith = require("./createImThemeOptionsZenith");
Object.keys(_createImThemeOptionsZenith).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _createImThemeOptionsZenith[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _createImThemeOptionsZenith[key];
    }
  });
});
var _themeOptions = require("./internal/theme-options");
Object.keys(_themeOptions).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _themeOptions[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _themeOptions[key];
    }
  });
});